/**
 * 格式化工具
 * 请以{ name }的方式引入改文件，以减小打包体积
 */

/**
 * 将数字格式化以万为单位
 * @number: 待格式化的数字
 * @dit: 小数位数，默认为0，如果传入false，则直接省略小数部分，不四舍五入。
 */
export const tenthousand = (number, dit = 0) => {
  if (!number || isNaN(number)) {
    return '0元'
  }

  if (number >= 10000) {
    if (typeof dit === 'boolean' && dit === false) {
      return parseInt(number / 10000, 10) + '万'
    }
    return (number / 10000).toFixed(dit) + '万'
  }
  if (typeof dit === 'boolean' && dit === false) {
    return parseInt(number, 10) + '元'
  }
  return number.toFixed(dit) + '元'
}

/**
 * 混淆手机号
 * @phone: 待格式化的数字
 */
export const mixphone = (phone) => {
  if (!phone) {
    return ''
  }
  return phone.slice(0, 3) + '****' + phone.slice(-4)
}

/**
 * 向一个 url 之后追加参数
 * @param {String} urlStr 需要追加参数的url
 * @param {Object} data 需要追加的参数
 * @return {String} 追加参数之后的url
 * @example url('a.html?pid=1', {name: 'xiaowang'}) => 'a.html?pid=1&name=xiaowang'
 */
export const urlParams = (urlStr, data) => {
  let _urlStr = urlStr
  const hashIndex = _urlStr.indexOf('#')
  let hashValue = ''
  if (hashIndex !== -1) {
    hashValue = _urlStr.substring(hashIndex, _urlStr.length)
    _urlStr = _urlStr.substring(0, hashIndex)
  }
  let param = ''
  for (const i in data) {
    param += `&${i}=${encodeURIComponent(data[i])}`
  }
  if (_urlStr.indexOf('?') === -1) {
    param = param.replace(/^\&/, '?')
  }
  return _urlStr + param + hashValue
}

export default {
  tenthousand,
  mixphone,
  urlParams,
}



// WEBPACK FOOTER //
// ./node_modules/@common/format/src/index.js